module.exports = {"130926100":"肃宁镇","130926101":"梁家村镇","130926102":"窝北镇","130926103":"尚村镇","130926104":"万里镇","130926105":"师素镇","130926106":"河北留善寺镇","130926107":"付家佐镇","130926205":"邵庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130926.json
// module id = 307
// module chunks = 0